import React from 'react';

const Input = ({
  label,
  value,
  onChange,
  placeholder,
  type = 'text',
  suffix,
  helper,
  error,
  disabled = false,
  min,
  step
}) => {
  const inputEl = (
    <input
      type={type}
      className="form-input"
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      disabled={disabled}
      min={min}
      step={step}
    />
  );

  return (
    <div className="form-group">
      {label && <label className="form-label">{label}</label>}
      {suffix ? (
        <div className="input-with-suffix">
          {inputEl}
          <span className="input-suffix">{suffix}</span>
        </div>
      ) : inputEl}
      {helper && !error && <div className="form-helper">{helper}</div>}
      {error && <div className="form-error">{error}</div>}
    </div>
  );
};

export default Input;
